import { render, staticRenderFns } from "./SidebarImageMessageCard.vue?vue&type=template&id=5956fd98&scoped=true"
import script from "./SidebarImageMessageCard.vue?vue&type=script&lang=js"
export * from "./SidebarImageMessageCard.vue?vue&type=script&lang=js"
import style0 from "./SidebarImageMessageCard.vue?vue&type=style&index=0&id=5956fd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5956fd98",
  null
  
)

export default component.exports